import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@/components/auth/AuthContext';
import { DataProvider } from './context/DataContext';
import { AppProvider } from './pages/providers/AppProvider';
import { ConfirmProvider } from './context/ConfirmContext';
import { ImageUpdateProvider } from './context/ImageUpdateContext';
import AppRouter from './router';
import RouteScrollToTop from './components/RouteScrollToTop';
import './main.css';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <AppProvider>
          <DataProvider>
            <ConfirmProvider>
              <ImageUpdateProvider>
                <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                  <RouteScrollToTop />
                  <div className="App">
                    <AppRouter />
                  </div>
                </BrowserRouter>
              </ImageUpdateProvider>
            </ConfirmProvider>
          </DataProvider>
        </AppProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
